import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import { useParams } from 'react-router-dom';
import NoAccessPage from './NoAccessPage';
import HelpTooltip from './HelpTooltip';
import {AlarmSettingsModal} from './Alarms/AlarmSettingsModal';

import { Carousel, OverlayTrigger, Tooltip, Button, FormControl, InputGroup } from 'react-bootstrap';
import Masonry from 'masonry-layout';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';

var $grid;

function Alarm (props) {
  const [carouselState, setCarouselState] = useState(0);
  const [promptDeleteConfirmation, setPromptDeleteConfirmation] = useState(false);
  const [alarm, setAlarm] = useState(props.alarm);
  const [restoring, setRestoring] = useState(false);
  const [notificationSetup, setNotificationSetup] = useState({});
  const { t } = useTranslation();

  useEffect(()=>{

  }, [carouselState]);
    

      // ----------------- Navigation / Step Handlers -----------------

  const NameEditHandler = () => {
    setCarouselState(1);
  };

  // ----------------- Helper Functions -----------------

  const FilterUsersforAdding = (allUsers, existingUsers) => {
    // existingUsers is not used in your original function, so we simply map allUsers
    return allUsers.map((user) => (
      <option key={user.Id} value={user.Id}>
        {user.Name}
      </option>
    ));
  };

  const ExistingUsersList = (users, deleteFunction) => {
    return users.map((user) => (
      <div key={user.UserID} className="row m-1 align-items-center">
        <div className="col-auto">{user.User.Name}</div>
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip>{t("components.alarmsettings.remove")} {user.User.Name}</Tooltip>}
        >
          <div
            className="btn btn-outline-primary col-auto ms-auto"
            onClick={() => deleteFunction(user)}
          >
            <i className="fad fa-trash fa-swap-opacity"></i>
          </div>
        </OverlayTrigger>
      </div>
    ));
  };

  // ----------------- AJAX Handlers for Notification Setup -----------------

  const NotificationSetupHandler = () => {
    $.ajax({
      url: '/api/AlarmSetupAPI/NotificationSetup',
      type: 'get',
      data: { AlarmID: alarm.AlarmID },
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      success: (response) => {
        const newNotificationSetup = {
          SetEmailUsers: ExistingUsersList(response.SetEmailUsers, DeleteUserforSetEmail),
          SetEmailUserList: FilterUsersforAdding(response.AllUsers, response.SetEmailUsers),
          SetSMSUsers: ExistingUsersList(response.SetSMSUsers, DeleteUserforSetSMS),
          SetSMSUserList: FilterUsersforAdding(response.AllUsers, response.SetSMSUsers),
          ResetEmailUsers: ExistingUsersList(response.ResetEmailUsers, DeleteUserforResetEmail),
          ResetEmailUserList: FilterUsersforAdding(response.AllUsers, response.ResetEmailUsers),
          ResetSMSUsers: ExistingUsersList(response.ResetSMSUsers, DeleteUserforResetSMS),
          ResetSMSUserList: FilterUsersforAdding(response.AllUsers, response.ResetSMSUsers),
        };
        setCarouselState(2);
        setNotificationSetup(newNotificationSetup);
        setTimeout(() => {
          $grid.reloadItems();
          $grid.layout();
        }, 250);
      },
    });
  };

  const AddUserforSetEmail = (event) => {
    $.ajax({
      url: '/api/AlarmSetupAPI/AddAlarmSetEmail',
      type: 'post',
      data: JSON.stringify({
        AlarmID: alarm.AlarmID,
        UserID: event.target.value,
      }),
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      success: (response) => {
        const newNotificationSetup = {
          SetEmailUsers: ExistingUsersList(response.SetEmailUsers, DeleteUserforSetEmail),
          SetEmailUserList: FilterUsersforAdding(response.AllUsers, response.SetEmailUsers),
          SetSMSUsers: notificationSetup.SetSMSUsers,
          SetSMSUserList: notificationSetup.SetSMSUserList,
          ResetEmailUsers: notificationSetup.ResetEmailUsers,
          ResetEmailUserList: notificationSetup.ResetEmailUserList,
          ResetSMSUsers: notificationSetup.ResetSMSUsers,
          ResetSMSUserList: notificationSetup.ResetSMSUserList,
        };
        setNotificationSetup(newNotificationSetup);
        setTimeout(() => {
          $grid.reloadItems();
          $grid.layout();
        }, 250);
      },
    });
  };

  const DeleteUserforSetEmail = (user) => {
    $.ajax({
      url: '/api/AlarmSetupAPI/DeleteAlarmSetEmail/',
      type: 'post',
      data: JSON.stringify(user),
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      success: (response) => {
        const newNotificationSetup = {
          SetEmailUsers: ExistingUsersList(response.SetEmailUsers, DeleteUserforSetEmail),
          SetEmailUserList: FilterUsersforAdding(response.AllUsers, response.SetEmailUsers),
          SetSMSUsers: notificationSetup.SetSMSUsers,
          SetSMSUserList: notificationSetup.SetSMSUserList,
          ResetEmailUsers: notificationSetup.ResetEmailUsers,
          ResetEmailUserList: notificationSetup.ResetEmailUserList,
          ResetSMSUsers: notificationSetup.ResetSMSUsers,
          ResetSMSUserList: notificationSetup.ResetSMSUserList,
        };
        setNotificationSetup(newNotificationSetup);
        setTimeout(() => {
          $grid.reloadItems();
          $grid.layout();
        }, 250);
      },
    });
  };

  const AddUserforSetSMS = (event) => {
    $.ajax({
      url: '/api/AlarmSetupAPI/AddAlarmSetSMS/',
      type: 'post',
      data: JSON.stringify({
        AlarmID: alarm.AlarmID,
        UserID: event.target.value,
      }),
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      success: (response) => {
        const newNotificationSetup = {
          SetEmailUsers: notificationSetup.SetEmailUsers,
          SetEmailUserList: notificationSetup.SetEmailUserList,
          SetSMSUsers: ExistingUsersList(response.SetSMSUsers, DeleteUserforSetSMS),
          SetSMSUserList: FilterUsersforAdding(response.AllUsers, response.SetSMSUsers),
          ResetEmailUsers: notificationSetup.ResetEmailUsers,
          ResetEmailUserList: notificationSetup.ResetEmailUserList,
          ResetSMSUsers: notificationSetup.ResetSMSUsers,
          ResetSMSUserList: notificationSetup.ResetSMSUserList,
        };
        setNotificationSetup(newNotificationSetup);
        setTimeout(() => {
          $grid.reloadItems();
          $grid.layout();
        }, 250);
      },
    });
  };

  const DeleteUserforSetSMS = (user) => {
    $.ajax({
      url: '/api/AlarmSetupAPI/DeleteAlarmSetSMS/',
      type: 'post',
      data: JSON.stringify(user),
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      success: (response) => {
        const newNotificationSetup = {
          SetEmailUsers: notificationSetup.SetEmailUsers,
          SetEmailUserList: notificationSetup.SetEmailUserList,
          SetSMSUsers: ExistingUsersList(response.SetSMSUsers, DeleteUserforSetSMS),
          SetSMSUserList: FilterUsersforAdding(response.AllUsers, response.SetSMSUsers),
          ResetEmailUsers: notificationSetup.ResetEmailUsers,
          ResetEmailUserList: notificationSetup.ResetEmailUserList,
          ResetSMSUsers: notificationSetup.ResetSMSUsers,
          ResetSMSUserList: notificationSetup.ResetSMSUserList,
        };
        setNotificationSetup(newNotificationSetup);
        setTimeout(() => {
          $grid.reloadItems();
          $grid.layout();
        }, 250);
      },
    });
  };

  const AddUserforResetEmail = (event) => {
    $.ajax({
      url: '/api/AlarmSetupAPI/AddAlarmResetEmail/',
      type: 'post',
      data: JSON.stringify({
        AlarmID: alarm.AlarmID,
        UserID: event.target.value,
      }),
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      success: (response) => {
        const newNotificationSetup = {
          SetEmailUsers: notificationSetup.SetEmailUsers,
          SetEmailUserList: notificationSetup.SetEmailUserList,
          ResetEmailUsers: ExistingUsersList(response.ResetEmailUsers, DeleteUserforResetEmail),
          ResetEmailUserList: FilterUsersforAdding(response.AllUsers, response.ResetEmailUsers),
          ResetSMSUsers: notificationSetup.ResetSMSUsers,
          ResetSMSUserList: notificationSetup.ResetSMSUserList,
        };
        setNotificationSetup(newNotificationSetup);
        setTimeout(() => {
          $grid.reloadItems();
          $grid.layout();
        }, 250);
      },
    });
  };

  const DeleteUserforResetEmail = (user) => {
    $.ajax({
      url: '/api/AlarmSetupAPI/DeleteAlarmResetEmail/',
      type: 'post',
      data: JSON.stringify(user),
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      success: (response) => {
        const newNotificationSetup = {
          SetEmailUsers: notificationSetup.SetEmailUsers,
          SetEmailUserList: notificationSetup.SetEmailUserList,
          SetSMSUsers: notificationSetup.SetSMSUsers,
          SetSMSUserList: notificationSetup.SetSMSUserList,
          ResetEmailUsers: ExistingUsersList(response.ResetEmailUsers, DeleteUserforResetEmail),
          ResetEmailUserList: FilterUsersforAdding(response.AllUsers, response.ResetEmailUsers),
          ResetSMSUsers: notificationSetup.ResetSMSUsers,
          ResetSMSUserList: notificationSetup.ResetSMSUserList,
        };
        setNotificationSetup(newNotificationSetup);
        setTimeout(() => {
          $grid.reloadItems();
          $grid.layout();
        }, 250);
      },
    });
  };

  const AddUserforResetSMS = (event) => {
    $.ajax({
      url: '/api/AlarmSetupAPI/AddAlarmResetSMS/',
      type: 'post',
      data: JSON.stringify({
        AlarmID: alarm.AlarmID,
        UserID: event.target.value,
      }),
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      success: (response) => {
        const newNotificationSetup = {
          SetEmailUsers: notificationSetup.SetEmailUsers,
          SetEmailUserList: notificationSetup.SetEmailUserList,
          SetSMSUsers: notificationSetup.SetSMSUsers,
          SetSMSUserList: notificationSetup.SetSMSUserList,
          ResetEmailUsers: notificationSetup.ResetEmailUsers,
          ResetEmailUserList: notificationSetup.ResetEmailUserList,
          ResetSMSUsers: ExistingUsersList(response.ResetSMSUsers, DeleteUserforResetSMS),
          ResetSMSUserList: FilterUsersforAdding(response.AllUsers, response.ResetSMSUsers),
        };
        setNotificationSetup(newNotificationSetup);
        setTimeout(() => {
          $grid.reloadItems();
          $grid.layout();
        }, 250);
      },
    });
  };

  const DeleteUserforResetSMS = (user) => {
    $.ajax({
      url: '/api/AlarmSetupAPI/DeleteAlarmResetSMS/',
      type: 'post',
      data: JSON.stringify(user),
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      success: (response) => {
        const newNotificationSetup = {
          SetEmailUsers: notificationSetup.SetEmailUsers,
          SetEmailUserList: notificationSetup.SetEmailUserList,
          SetSMSUsers: notificationSetup.SetSMSUsers,
          SetSMSUserList: notificationSetup.SetSMSUserList,
          ResetEmailUsers: notificationSetup.ResetEmailUsers,
          ResetEmailUserList: notificationSetup.ResetEmailUserList,
          ResetSMSUsers: ExistingUsersList(response.ResetSMSUsers, DeleteUserforResetSMS),
          ResetSMSUserList: FilterUsersforAdding(response.AllUsers, response.ResetSMSUsers),
        };
        setNotificationSetup(newNotificationSetup);
        setTimeout(() => {
          $grid.reloadItems();
          $grid.layout();
        }, 250);
      },
    });
  };

  // ----------------- Alarm Field Change Handlers -----------------

  const SignalChange = (event) => {
    const updatedAlarm = { ...alarm };
    updatedAlarm.SignalID = event.target.value;
    for (let i = 0; i < props.signals.length; i++) {
      if (props.signals[i].SignalID == event.target.value) {
        updatedAlarm.SignalID = props.signals[i];
        setAlarm(updatedAlarm);
        break;
      }
    }
  };

  const MessageStringChange = (event) => {
    const updatedAlarm = { ...alarm, MessageString: event.target.value };
    setAlarm(updatedAlarm);
  };

  const ClearedStringChange = (event) => {
    const updatedAlarm = { ...alarm, ClearedString: event.target.value };
    setAlarm(updatedAlarm);
  };

  const NoDataClickHandler = () => {
    const updatedAlarm = { ...alarm, NoDataAlarm: !alarm.NoDataAlarm };
    setAlarm(updatedAlarm);
  };

  const UpperThresholdChange = (event) => {
    const updatedAlarm = { ...alarm, UpperThreshold: event.target.value };
    setAlarm(updatedAlarm);
  };

  const LowerThresholdChange = (event) => {
    const updatedAlarm = { ...alarm, LowerThreshold: event.target.value };
    setAlarm(updatedAlarm);
  };

  const SetTimeChange = (event) => {
    const updatedAlarm = { ...alarm, SetTime: event.target.value };
    setAlarm(updatedAlarm);
  };

  const ResetTimeChange = (event) => {
    const updatedAlarm = { ...alarm, ResetTime: event.target.value };
    setAlarm(updatedAlarm);
  };

  // ----------------- Save / API Update Handlers -----------------

  const NameSaveHandler = () => {
    $.ajax({
      url: '/api/AlarmSetupAPI/UpdateAlarm/',
      type: 'post',
      data: JSON.stringify(alarm),
      contentType: 'application/json; charset=utf-8',
      success: (response) => {
        setCarouselState(0);
      },
    });
  };

  const ThresholdSaveHandler = () => {
    $.ajax({
      url: '/api/AlarmSetupAPI/UpdateThresholds/',
      type: 'post',
      data: JSON.stringify(alarm),
      contentType: 'application/json; charset=utf-8',
      success: (response) => {
        setCarouselState(0);
        ReturnToStartHandler();
      },
    });
  };

  // ----------------- Other Handlers -----------------

  const onSlideHandler = () => {
    $grid.layout();
  };

  const PromptDeleteConfirmation = () => {
    setPromptDeleteConfirmation(!promptDeleteConfirmation);
  };

  const DeleteConfirmation = () => {
    $.ajax({
      url: '/api/AlarmSetupAPI/DeleteAlarm/',
      type: 'post',
      data: JSON.stringify({ AlarmID: alarm.AlarmID }),
      contentType: 'application/json; charset=utf-8',
      success: () => {
        setPromptDeleteConfirmation(false);
        props.DeleteAlarm(alarm.AlarmID);
        setTimeout(() => {
          $grid.reloadItems();
          $grid.layout();
        }, 10);
      },
    });
  };

  const ReturnToStartHandler = () => {
    setRestoring(true);
    $.ajax({
      url: '/api/AlarmSetupAPI/GetAlarm/',
      type: 'get',
      data: { AlarmID: alarm.AlarmID },
      success: (response) => {
        const updatedAlarm = JSON.parse(response);
        setAlarm(updatedAlarm);
        setCarouselState(0);
        setRestoring(false);
        setTimeout(() => {
          $grid.reloadItems();
          $grid.layout();
        }, 60);
      },
    });
  };

    return (<div className="grid-item col-md-4 p-0" id={alarm.AlarmID + "-Card"}>
        <div className="m-2 shadow p-0 card" >
            <div className="card-header" style={{ 'height': '64px' }}>
                <div className="align-items-center" style={{ position: 'absolute' }}>{alarm.MessageString} {props.editaccess && carouselState != 1 ? <div className="btn btn-outline-primary p-0 ps-1 pe-1" onClick={NameEditHandler}><i className="fad fa-edit fa-swap-opacity"></i></div> : ""}</div>
            </div>
            <div className="card-body p-3">
                <Carousel controls={false} indicators={false} interval={null} activeIndex={carouselState} onSlide={onSlideHandler} onSlid={onSlideHandler}>
                    <Carousel.Item style={{ background: 'white' }}>
                        <div className="row m-1 align-items-center">
                            {t("components.alarmsettings.signal")}: {alarm.Signal.NiceName}
                        </div>
                        <hr />
                        <div className="row m-1 align-items-center">
                            <HelpTooltip className="col-md-auto" placement="bottom" helptext={t("components.alarmsettings.alarmsettings-helptext")} />
                            <Button className="col" onClick={() => props.OpenSettings(alarm.AlarmID)}>{t("components.alarmsettings.alarmsettings")}</Button>
                        </div>
                        <hr />
                        <div className="row m-1 align-items-center" style={{ float: 'center' }}>
                            <HelpTooltip className="col-md-auto" placement="bottom" helptext={t("components.alarmsettings.notificationsetup-helptext")} />
                            <Button className="col" onClick={NotificationSetupHandler}>{t("components.alarmsettings.notificationsetup")}</Button>
                        </div>
                        <hr />
                        <div className="row m-1 align-items-center">
                            {props.editaccess ? <OverlayTrigger
                                placement="top"
                                show={promptDeleteConfirmation}
                                overlay={
                                    <Tooltip>
                                        <div className="align-items-center">{t("common.confirmdelete")}: <div className="btn btn-danger" onClick={DeleteConfirmation}><i className="fad fa-trash"></i></div></div>
                                    </Tooltip>
                                }>
                                <div className="btn btn-outline-danger ms-auto" onClick={PromptDeleteConfirmation}><i className="fad fa-trash"></i></div>
                            </OverlayTrigger> : ""}
                        </div>
                    </Carousel.Item>
                    <Carousel.Item style={{ background: 'white' }}>
                        <div className="btn btn-outline-primary" onClick={ReturnToStartHandler}> <i className="fad fa-chevron-double-left"></i></div>
                        <InputGroup className="justify-content-center mb-2">
                            <InputGroup.Text>{t("components.alarmsettings.alarmtriggeredmessage")}: </InputGroup.Text>
                            <FormControl
                                aria-describedby="basic-addon3"
                                value={alarm.MessageString}
                                onChange={MessageStringChange}>
                            </FormControl>
                        </InputGroup>
                        <InputGroup className="justify-content-center mb-2">
                            <InputGroup.Text>{t("components.alarmsettings.alarmclearedmessage")}:   </InputGroup.Text>
                            <FormControl
                                aria-describedby="basic-addon3"
                                value={alarm.ClearedString}
                                onChange={ClearedStringChange}>
                            </FormControl>
                        </InputGroup>
                        <div className="btn btn-primary" onClick={NameSaveHandler}>{t("common.save")}</div>
                    </Carousel.Item>
                    {/* <Carousel.Item style={{ background: 'white' }}>
                        <div className="mb-2 row ms-0">
                            <div className="btn col-md-auto btn-outline-primary float-left" onClick={ReturnToStartHandler}> <i className="fad fa-chevron-double-left"></i></div>
                            <div className="input-group col justify-content-end" onClick={NoDataClickHandler}>
                                <div className="input-group-text">
                                    <input className="form-check-input" defaultChecked={alarm.NoDataAlarm} type="checkbox" aria-label="No Data Alarm" />
                                </div>
                                <span class="input-group-text">{t("components.alarmsettings.nodataalarm")}</span>
                            </div>
                        </div>
                        <InputGroup className="justify-content-center mb-2">
                            <InputGroup.Text>
                                <HelpTooltip placement="top" helptext="The amount of time the signal value needs to be outside the thresholds before the alarm is triggered." />
                                &nbsp;
                                Set Time (s):
                            </InputGroup.Text>
                            <FormControl
                                aria-describedby="basic-addon3"
                                value={alarm.SetTime}
                                type="number"
                                onChange={SetTimeChange}>
                            </FormControl>
                        </InputGroup>
                        <InputGroup className="justify-content-center mb-2">
                            <InputGroup.Text>
                                <HelpTooltip placement="top" helptext="The amount of time the signal value needs to be within the thresholds before an active alarm is reset." />
                                &nbsp;
                                Reset Time (s):
                            </InputGroup.Text>
                            <FormControl
                                aria-describedby="basic-addon3"
                                value={alarm.ResetTime}
                                type="number"
                                onChange={ResetTimeChange}
                                disabled={alarm.NoDataAlarm}>
                            </FormControl>
                        </InputGroup>
                        <InputGroup className="justify-content-center mb-2">
                            <InputGroup.Text>Upper threshold: </InputGroup.Text>
                            <FormControl
                                aria-describedby="basic-addon3"
                                value={alarm.UpperThreshold}
                                type="number"
                                onChange={UpperThresholdChange}
                                disabled={alarm.NoDataAlarm}>
                            </FormControl>
                        </InputGroup>
                        <InputGroup className="justify-content-center mb-2">
                            <InputGroup.Text>Lower threshold: </InputGroup.Text>
                            <FormControl
                                aria-describedby="basic-addon3"
                                value={alarm.LowerThreshold}
                                type="number"
                                onChange={LowerThresholdChange}
                                disabled={alarm.NoDataAlarm}>
                            </FormControl>
                        </InputGroup>
                        <div className="btn btn-primary" onClick={ThresholdSaveHandler}>Save</div>
                    </Carousel.Item> */}
                    <Carousel.Item style={{ background: 'white' }}>
                        <div className="mb-1">
                            <div className="btn btn-outline-primary float-left" onClick={ReturnToStartHandler}> <i className="fad fa-chevron-double-left"></i></div>
                        </div>
                        <div className="text-center">{t("components.alarmsettings.setemail")}</div>
                        <div className="input-group">
                            <select className="m-1 form-control" onChange={AddUserforSetEmail} placeholder="Set Email" value="Set Email">
                                <option value="null"></option>
                                {notificationSetup.SetEmailUserList}
                            </select>
                        </div>
                        {notificationSetup.SetEmailUsers}
                        <hr />
                        <div className="text-center">{t("components.alarmsettings.setsms")}</div>
                        <div className="input-group">
                            <select className="m-1 form-control" onChange={AddUserforSetSMS} value="Add User" placeholder="Set SMS">
                                <option value="null"></option>
                                {notificationSetup.SetSMSUserList}
                            </select>
                        </div>
                        {notificationSetup.SetSMSUsers}
                        <hr />
                        <div className="text-center">{t("components.alarmsettings.resetemail")}</div>
                        <div className="input-group">
                            <select className="m-1 form-control" onChange={AddUserforResetEmail} placeholder="Reset Email">
                                <option value="null"></option>
                                {notificationSetup.ResetEmailUserList}
                            </select>
                        </div>
                        {notificationSetup.ResetEmailUsers}
                        <hr />
                        <div className="text-center">{t("components.alarmsettings.resetsms")}</div>
                        <div className="input-group">
                            <select className="m-1 form-control" onChange={AddUserforResetSMS} placeholder="Reset SMS">
                                <option value="null"></option>
                                {notificationSetup.ResetSMSUserList}
                            </select>
                        </div>
                        {notificationSetup.ResetSMSUsers}
                    </Carousel.Item>
                </Carousel>
            </div>
        </div>
    </div >);
}

function AlarmsList(props) {
    const { t } = useTranslation();
    const [signals] = useState(props.signals)
    const [alarms, setAlarms] = useState(props.alarms)
    const [newalarmname, setNewAlarmName] = useState("")
    const [signalid, setSignalID] = useState("")
    const [renderalarms, setrenderalarms] = useState([])
    const [showModal, setShowModal] = useState(false)
    const [selected, setSelected] = useState(false)

    const handleClose = () => setShowModal(false);

    const RenderAlarms = (alarmsInfo) => {
        let newrenderalarms = [];
        for (let i = 0; i < alarmsInfo.length; i++) {
            newrenderalarms.push(
                <Alarm
                    key={alarmsInfo[i].AlarmID + "cardkey"}
                    alarm={alarmsInfo[i]}
                    signals={signals}
                    DeleteAlarm={DeleteAlarm}
                    alarms={alarmsInfo}
                    editaccess={true}
                    OpenSettings={props.OpenSettings} />
            );
        }
        setrenderalarms(newrenderalarms);

        // Reshuffle alarm cards
        setTimeout(function () {
            $grid.reloadItems();
            $grid.layout();
        }, 100);
    }

    useEffect(() => {
        var masonryOptions = {
            itemSelector: '.grid-item',
            animate: true,
            stagger: 50,
            percentPosition: true
        };

        var elem = document.querySelector('#cards');
        $grid = new Masonry(elem, masonryOptions);

        $grid.reloadItems();
        $grid.layout();
    }, []);

    useEffect(() => {
        setAlarms(props.alarms);
    }, [props.alarms]);

    useEffect(() => {
        RenderAlarms(alarms);

        setTimeout(function () {
            $grid.reloadItems();
            $grid.layout();
        }, 100);
    }, [signals, alarms]);


    function AddAlarm() {
        if (!selected) {
            setShowModal(true);
            return;
        }
        var newAlarm = {
            MessageString: newalarmname,
            SignalID: signalid
        }
        setSelected(!selected);
        // API call to get access level and signals list
        $.ajax({
            url: '/api/AlarmSetupAPI/CreateAlarm/',
            type: 'post',
            data: JSON.stringify(newAlarm),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (response) {
                var newalarms = alarms;
                var alarmReturn = response;
                newalarms.push(alarmReturn);
                setAlarms(newalarms);
                var newrenderalarms = [];
                for (var i = 0; i < newalarms.length; i++) {
                    newrenderalarms.push(<Alarm key={newalarms[i].AlarmID + "cardkey"} alarm={newalarms[i]} signals={signals} DeleteAlarm={DeleteAlarm} OpenSettings={props.OpenSettings} alarms={newalarms} editaccess={true} />);
                }
                setrenderalarms(newrenderalarms);
                setNewAlarmName("");
                setSignalID("");
                props.OpenSettings(alarmReturn.AlarmID);
                setTimeout(function () {
                    $grid.reloadItems();
                    $grid.layout();

                }.bind(this), 50);
            }.bind(this)
        });
    }

    function DeleteAlarm(AlarmID) {
        console.log("Deleting " + AlarmID);
        //let oldalarms = [...alarms];
        let newalarms = alarms.filter(obj => obj.AlarmID !== AlarmID);
        setAlarms(newalarms);
    }

    function AlarmNamePressHandler(event) {
        if (event.key == "Enter") {
            AddAlarm();
        }
    }

    function AlarmNameChangeHandler(event) {
        setNewAlarmName(event.target.value);
    }

    function SignalIDChangeHandler(event) {
        if (event.target.value != null) {
            setSelected(true)
        }
        setSignalID(event.target.value);
    }

    var signalslist = [];
    var i;
    for (i = 0; i < props.signals.length; i++) {
        signalslist.push(<option key={props.signals[i].SignalID} value={props.signals[i].SignalID}>{props.signals[i].NiceName}</option>);
    }
    return (<div>
        {renderalarms}
        <div className="grid-item col-md-4 p-0">
            <div className="m-2 shadow p-0 card" >
                <div className="card-body p-3 text-center">
                    <label>{t("components.alarmsettings.createalarm")}</label>
                    <div className="input-group">
                        <input type="text" className="form-control" value={newalarmname} onChange={AlarmNameChangeHandler} onKeyPress={AlarmNamePressHandler} placeholder={t("components.alarmsettings.alarmname")} aria-label={t("components.alarmsettings.alarmname")} aria-describedby="basic-addon2" />
                    </div>
                    <br></br>

                    <div className="input-group">
                        <select className="form-select" onChange={SignalIDChangeHandler} value={signalid}>
                            <option value="null"></option>
                            {signalslist}
                        </select>
                        <a className="btn btn-outline-primary" onClick={AddAlarm} ><i className="far fa-plus-circle"></i></a>

                        <Modal show={showModal} onHide={handleClose}>
                            <Modal.Header closeButton>
                                <Modal.Title>{t("common.error")}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>{t("components.alarmsettings.selectsignal")}</Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleClose}>
                                    {t("common.close")}
                                </Button>
                            </Modal.Footer>
                        </Modal>

                    </div>
                </div>
            </div>
        </div>
    </div>)
}


export function AlarmSetup(props) {
    const { id } = useParams();
    const [alarms, setAlarms] = useState([])
    const [signals, setSignals] = useState([])
    const [frequency, setFrequency] = useState(1800)
    const [showSettings, setShowSettings] = useState(false)
    const [currentAlarmID, setCurrentAlarmID] = useState(0)

    //This needs to be here because only the routed pages have access to id. This sends the id back to the navbar.
    useEffect(() => props.SiteGUIDSetter(id), [id]);

    useEffect(() => {
        $.ajax({
            url: '/api/AlarmSetupAPI/GetAlarms/',
            type: 'get',
            data: {
                SiteGUID: id
            },
            success: function (response) {
                response = JSON.parse(response);

                setAlarms(response.Alarms);
                setSignals(response.Signals);

                setTimeout(function () {
                    $grid.layout();

                }, 100);
            }.bind(this)
        });

    }, [id]);

    function OpenSettings(AlarmID) {
        setCurrentAlarmID(AlarmID);
        setShowSettings(true);
    }

    return (
        props.auth !== undefined ?
            props.auth > 0 ?
                <div>
                    <div id="cards" className="container-fluid p-0">
                        <div className="grid-item col-1"></div>
                        <AlarmsList SiteGUID={id} signals={signals} alarms={alarms} OpenSettings={OpenSettings} />
                    </div>
                    <AlarmSettingsModal alarmID={currentAlarmID} display={showSettings} closeModal={() => setShowSettings(false)}  />
                </div>
                :
                <NoAccessPage />
            : <></>);
};

